import {z} from 'zod';
import {translations} from 'presentation/translations-new';

const {form} = translations['pt-br'].privateFlow.help.sendYourMessage;
const {requiredField} = translations['pt-br'].commons;
const {mail, phone, message} = form;

export const formSchema = z.object({
	subject: z.string().min(1, {message: requiredField}),
	email: z.string().min(1, {message: requiredField}).email({message: mail.error}),
	phone: z
		.string()
		.optional()
		.refine(value => !value || value.replace(/\D/g, '').length >= 10, {
			message: phone.error,
		}),
	message: z.string().min(1, {message: requiredField}).min(20, {message: message.info}),
});

export type IFormData = z.infer<typeof formSchema>;
